var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState, useEffect, useCallback, memo } from "react";
import BaseModal from './baseModal';
import { tools } from '../../utils/index';
import { WithErrorHandler } from '../../components/WithErrorHandler';
var RecommondSlotNode = memo(function (props) {
    var _a = __read(useState([]), 2), selectCars = _a[0], setSelectCars = _a[1];
    var onItemClick = useCallback(function (item) {
        var selecteds = !selectCars.includes(item.id) ? __spreadArray(__spreadArray([], __read(selectCars)), [item.id]) : selectCars.filter(function (id) { return item.id !== id; });
        setSelectCars(selecteds);
        if (typeof props.onItemClick != 'undefined') {
            props.onItemClick(selecteds, item);
        }
    }, [selectCars]);
    return (React.createElement("div", { className: "recommendCar-wrap" },
        React.createElement("div", { className: "recommend-list", id: "recommendList" }, props.carList &&
            props.carList.map(function (item, index) {
                return (React.createElement("div", { className: "car-item-wrap", key: index, style: {
                        background: selectCars.includes(item.id) ? 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(253,85,47,0.08) 100%' : ''
                    }, onClick: function () { return onItemClick(item); } },
                    React.createElement("div", { className: "car-item-top" },
                        React.createElement("img", { src: item.guidePic || "//img2.xgo-img.com.cn/line_head_big/9/240x180/60740d157bbd8.png" })),
                    React.createElement("div", { className: "car-item-bottom" },
                        React.createElement("div", { className: "car-type-name" }, item.name || ""),
                        React.createElement("div", { className: "car-type-info" }, item.subTitle || ""),
                        React.createElement("div", { className: "car-type-price" }, item.guidePrice || ""),
                        selectCars.includes(item.id) && React.createElement("div", { className: "car-type-check" }))));
            }))));
});
var Index = function (props) {
    var _a, _b;
    /** 车型信息 */
    var _c = __read(useState({
        multiProductId: "",
        multiLineId: "",
    }), 2), ajaxParams = _c[0], setAjaxParams = _c[1];
    // 推荐车列表
    var _d = __read(useState([]), 2), carList = _d[0], setCarList = _d[1];
    // 提交参数列表 lineId[] / productId[]
    var _e = __read(useState([]), 2), ids = _e[0], setIds = _e[1];
    var _f = __read(useState(0), 2), listType = _f[0], setListType = _f[1];
    /** 城市信息 */
    var _g = __read(useState({
        cityid: 613,
        cityname: "北京",
    }), 2), cityInfo = _g[0], setCityInfo = _g[1];
    // 车辆卡片点击事件
    var onCarItemClick = useCallback(function (selection, item) {
        setIds(selection);
    }, []);
    useEffect(function () {
        if (typeof window.getCity !== "undefined") {
            window.getCity(function (res) {
                setCityInfo({
                    cityid: res.cityid,
                    cityname: res.name,
                });
            });
        }
    }, []);
    useEffect(function () {
        var el = document.getElementById('recommendList');
        if (props.visible) {
            el === null || el === void 0 ? void 0 : el.addEventListener('touchmove', handleMove);
            el === null || el === void 0 ? void 0 : el.addEventListener('touchstart', handleMoveStart);
        }
        else {
            el === null || el === void 0 ? void 0 : el.removeEventListener('touchmove', handleMove, false);
            el === null || el === void 0 ? void 0 : el.removeEventListener('touchstart', handleMoveStart, false);
        }
    }, [props.visible]);
    // 同级车滑动事件 
    var handleMove = useCallback(function (e) {
        e.stopPropagation(); // 阻止冒泡, 因为外层 modal 应用了 smartscoller  会禁掉横向滑动
    }, []);
    // 同级车滑动开始事件 
    var handleMoveStart = useCallback(function (e) {
        var _a;
        // 看 html 是否有禁止滑动样式<html class='noscrollRoot'，否 给html 添加禁止滑动样式 这是因为 citypop内部 移除了
        var htmlDom = document.querySelector('html');
        if (!((_a = htmlDom.classList) === null || _a === void 0 ? void 0 : _a.contains('noscrollRoot'))) {
            htmlDom.classList.add('noscrollRoot');
        }
    }, []);
    useEffect(function () {
        var _a, _b;
        getRecommenList((_a = props.prodInfoRelate) === null || _a === void 0 ? void 0 : _a.productId, (_b = props.prodInfoRelate) === null || _b === void 0 ? void 0 : _b.lineId);
    }, [(_a = props.prodInfoRelate) === null || _a === void 0 ? void 0 : _a.productId, (_b = props.prodInfoRelate) === null || _b === void 0 ? void 0 : _b.lineId]);
    /** 获取同级推荐车数据 */
    var getRecommenList = useCallback(function (productId, lineId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, _a, list, type;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, tools.request(props.recommendServeUrl || "//service.58che.com/unify/v1/recommendpopup/", props.recommendQueryParms || { productId: productId || "", lineId: lineId || "2421" }, "jsonp", { method: "get" })];
                case 1:
                    res = _b.sent();
                    if (res.code == 0 && res.entity.data) {
                        _a = res.entity.data, list = _a.list, type = _a.listType;
                        list === null || list === void 0 ? void 0 : list.map(function (item) { return item.checked = false; });
                        setCarList(list);
                        setListType(type);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        var _a, _b;
        var _ids = (ids === null || ids === void 0 ? void 0 : ids.join(',')) || '';
        if (listType == 1) {
            setAjaxParams(__assign(__assign({}, (_a = props.submitRelate) === null || _a === void 0 ? void 0 : _a.ajaxParams), { multiProductId: "", multiLineId: _ids }));
        }
        else if (listType == 2) {
            setAjaxParams(__assign(__assign({}, (_b = props.submitRelate) === null || _b === void 0 ? void 0 : _b.ajaxParams), { multiProductId: _ids, multiLineId: "" }));
        }
    }, [ids]);
    return (React.createElement("div", null,
        React.createElement(BaseModal, __assign({}, props, { topSlotNode: React.createElement(RecommondSlotNode, { carList: carList, onItemClick: onCarItemClick }), cityinfoRelate: {
                show: true,
                defaultCityInfo: {
                    cityid: cityInfo.cityid,
                    cityname: cityInfo.cityname,
                },
            }, submitRelate: {
                ajaxParams: ajaxParams,
            }, prodInfoRelate: {
                // 同级别推荐不需要车型选择
                showProdArea: false
            }, autoScrollId: 'recommendList' }))));
};
export default WithErrorHandler(memo(Index));
